import { render, staticRenderFns } from "./imagens.vue?vue&type=template&id=065da235&scoped=true&"
import script from "./imagens.vue?vue&type=script&lang=js&"
export * from "./imagens.vue?vue&type=script&lang=js&"
import style0 from "./imagens.vue?vue&type=style&index=0&id=065da235&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065da235",
  null
  
)

export default component.exports